import { action, observable } from 'mobx';
import {  getDeviceToken } from '@/services/Home';
import { deviceTotalTypes } from '@/types/APITypes';
import DeviceStore from '@/stores/device/index';
import * as R from 'ramda';

class DeviceSyncStore {

    @observable.ref cloudPlay: any;

    @observable.ref deviceSyncList: any[] = [];
    @observable.ref accessKeyId: string;
    @observable.ref masterId: string;
   @observable.ref masterName: string;
  @observable.ref slaveIds: deviceTotalTypes[] = [];
    @observable.ref packageName: string;
    @observable.ref cap: string;
    @observable.ref token: string;

    @observable sizeType: string;
    @observable rotateType: string;
    @observable.ref soundType: string;
    @observable.ref totalCheckedIndex: number;


    @action.bound setSizeType(type: string) {
        window.localStorage.setItem('sizeType', type);
        this.sizeType = type
    }

    @action.bound setRotateType(type: string) {
        window.localStorage.setItem('rotateType', type);
        this.rotateType = type
    }

    @action.bound async getDeviceSyncStore() {
        //获取设备列表
      let list: any[] = []
      if (DeviceStore.DeviceBaseStore.selectedCids.length !== 0) {
  
      list =   DeviceStore.DeviceBaseStore.selectedCids.map(cid =>
          R.find(R.propEq('cid', cid))(DeviceStore.DeviceBaseStore.deviceList
          ));
      } else {
        list = JSON.parse( window.localStorage.getItem('deviceList') || '{}')
      }
  
      window.localStorage.setItem('deviceList', JSON.stringify(list))
  
      //获取云机同步token
        const [errorT, resultT] = await getDeviceToken({ serviceId: list[0].id });
        if (errorT) return;


        this.deviceSyncList = list
        this.accessKeyId = resultT.cid;
        this.masterId = list[0].cid;
        this.masterName = list[0].deviceName || list[0].device_name || list[0].cid;
        this.packageName = resultT.packageName;
        this.cap = '1.00';
        this.token = resultT.accessToken;

        
        this.slaveIds = list.map((r: any) => {
            return {
                phoneId: r.cid,
                domId: r.cid,
              deviceName: r.deviceName || r.device_name
            }
        })

    }

}

export default DeviceSyncStore;
